<template>
  <v-dialog v-model="value" max-width="700px">
    <v-card :loading="loading">
      <v-card-title class="headline font-weight-thin">Delete Confirmation</v-card-title>
      <v-card-text>
        Are you sure you want to delete
        <span class="font-weight-bold">{{ tag.label }} (ID: {{ tag.id }})</span>?
      </v-card-text>
      <v-card-actions class="pa-4" v-show="!loading">
        <v-spacer></v-spacer>
        <v-btn @click="close" class="mr-2" data-cy="cancelDelete" outlined>Cancel</v-btn>
        <v-btn class="elevation-0 font-weight-bold" color="red" data-cy="confirmDelete" @click="submit" outlined
          >Delete</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  computed: {
    loading() {
      return !this.tag.id;
    },
    ...mapState({
      tag: state => state.admin.tag.record,
      serviceAreaId: state => state.session.serviceArea,
    }),
  },
  methods: {
    close() {
      this.$emit("input", false);
    },
    async submit() {
      const { label } = this.tag;

      try {
        await this.deleteRecord(this.tag);
        this.$emit("input", false);
        this.$notifySuccess({ message: `Successfully deleted ${label}` });
      } catch (e) {
        return this.$notifyError({
          message: `Could not delete tag value.`,
        });
      }
      try {
        await this.fetchList(this.serviceAreaId);
      } catch (e) {
        console.error(e);
        this.$notifyError({
          message: `Could not refresh release note list.`,
        });
      }
      this.close();
    },
    ...mapActions({
      deleteRecord: "admin/tag/delete",
      fetchList: "admin/tag/fetchList",
    }),
  },
  props: {
    value: {},
  },
};
</script>
